//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../library/umum'
import WILAYAH from  '../../../library/getWilayah'
import uniqid from 'uniqid';

export default {
  data() {
    return {

        form : {
            id : '',
            uraian : '',
            alamat : '',
            noreg : '',
            no_perdes_pembentukan : '',
            sop : '',
            ad_art : '',
            status_kantor : '',
            buku_tamu : '',
            perabot_kantor : '',
            sarana_penunjang : '',
            profil: '',
            createdAt : '',
            des_kel : '',
            kecamatan : '',
        },


        pelops : {
            id : '',
            id_bumDes : '',
            nama : '',
            alamat : '',
            pendidikan_terahir : '',
            no_telp : '',
            honor : '',
            createdAt : '',
            des_kel : '',
        },

        list_data : [],
        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,

        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_lihat : false,

        mdl_pelaops : false,
        mdl_usaha : false,
        mdl_pelatihan : false,
        mdl_kendaraan : false,
        mdl_sarana : false,



        btn_add: false,

        disable_kec : false,
        disable_des : false,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              kecamatan : this.form.kecamatan,
              des_kel : this.form.des_kel,
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
            //   console.log(res_data);
      });
    },

    addData : function(number) {
        this.form.id = uniqid();
        // this.form.keterangan = document.getElementById("editor").value;
        // console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "addData", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

        // console.log(document.getElementById("editor").value)
    },

    editData : function(){
        // this.form.keterangan = document.getElementById("editor").value;
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){

      this.form.id = data.id
      this.form.uraian = data.uraian
      this.form.alamat = data.alamat
      this.form.noreg = data.noreg
      this.form.no_perdes_pembentukan = data.no_perdes_pembentukan
      this.form.sop = data.sop
      this.form.ad_art = data.ad_art
      this.form.status_kantor = data.status_kantor
      this.form.buku_tamu = data.buku_tamu
      this.form.perabot_kantor = data.perabot_kantor
      this.form.sarana_penunjang = data.sarana_penunjang
      this.form.profil= data.profil
      this.form.createdAt = data.createdAt
      this.form.des_kel = data.des_kel

    },

    emptytData : function(data){
 
            this.form.id = '';
            this.form.uraian = '';
            this.form.keterangan= null;
            this.form.createdAt = '';
    },

    checkAdd : function(){
      if (this.form.des_kel == null || this.form.des_kel == '' || this.form.des_kel == undefined) {
        alert ("MOHON PILIH DESA/KELURAHAN TERLEBIH DAHULU..!!")
      } else {
        this.mdl_add = true; 
        this.$store.commit('addEditor');
      }
    },

    chageDesa(){
      this.form.des_kel = ''
      if (this.form.kecamatan == '' || this.form.kecamatan == undefined || this.form.kecamatan == null) {
        WILAYAH.postDesKelAutocomplete();
      } else {
        WILAYAH.postDesKelAutocomplete(this.form.kecamatan);
        
      }
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },

        tunggu : async function(){
          await WILAYAH.getListKecamatan();
          await WILAYAH.getListDesKelFull();

          if (profile.des_kel == null || profile.des_kel == undefined || profile.des_kel == '') {
            console.log(this.$store.state.listDesKel[0].uniqid)
            this.form.des_kel = this.$store.state.listDesKel[0].uniqid
          } else {
            this.form.des_kel = profile.des_kel
          }
        },

        filterSelect : function(profile){
          if (profile.aksesWilayah == 0) {
            WILAYAH.getListDesKelFull();
            this.form.des_kel = profile.des_kel
            this.disable_des = true
            this.disable_kec = true
          } else if (profile.aksesWilayah == 1) {
            this.form.kecamatan = profile.kecamatan
            WILAYAH.postDesKel(profile.kecamatan)
            this.disable_kec = true
            this.disable_des = false

          } else if (profile.aksesWilayah == 2) {
            WILAYAH.getListDesKelFull();
            this.disable_kec = false
            this.disable_des = false
          }
        },

    // ====================================== PAGINATE ====================================

  },

  mounted () {

    this.form.tahun = UMUM.getTahun();
    WILAYAH.getListKecamatan();
    
    var profilex = JSON.parse(localStorage.profile)
    var profile = profilex.profile
    this.$store.state.ID_DES_KEL = profile.des_kel
  
    // this.tunggu();
   
    this.filterSelect(profile)
    // console.log(this.form.des_kel)

    this.getView();

    new FroalaEditor('textarea#froala-editor')
        // tinymce.init({
        //   selector: 'textarea',
        //   plugins: 'a11ychecker advcode casechange formatpainter linkchecker autolink lists checklist media mediaembed pageembed permanentpen powerpaste table advtable tinycomments tinymcespellchecker',
        //   toolbar: 'a11ycheck addcomment showcomments casechange checklist code formatpainter pageembed permanentpen table',
        //   toolbar_mode: 'floating',
        //   tinycomments_mode: 'embedded',
        //   tinycomments_author: 'Author name',
        // });
  },
}
